import api from '@/lib/api';

export type OAuthClientKind = 'DYNAMIC' | 'METADATA_DOCUMENT';

export interface OAuthAuthorizationRequest {
  clientId: string;
  clientName: string | null;
  clientUri: string | null;
  clientKind: OAuthClientKind;
  clientHost: string | null;
  redirectUri: string;
  redirectHost: string | null;
  loopbackRedirect: boolean;
  /** For a redirect through an app's own scheme, the app the browser opens, e.g. `cursor://anysphere.cursor-mcp`. */
  appRedirect: string | null;
  requestedScopes: string[];
  expiresAt: string;
}

export interface ConnectedApp {
  grantId: string;
  clientId: string;
  clientName: string | null;
  clientKind: OAuthClientKind;
  scopes: string[];
  createdAt: string;
  lastUsedAt: string | null;
  expiresAt: string;
}

const REQUESTS = 'oauth/authorization-requests';
const GRANTS = 'oauth/grants';

export async function getAuthorizationRequest(requestId: string) {
  const { data } = await api.get<OAuthAuthorizationRequest>(
    `${REQUESTS}/${encodeURIComponent(requestId)}`
  );
  return data;
}

export async function approveAuthorizationRequest(requestId: string, scopes: string[]) {
  const { data } = await api.post<{ redirectUrl: string }>(
    `${REQUESTS}/${encodeURIComponent(requestId)}/approve`,
    { scopes }
  );
  return data.redirectUrl;
}

export async function denyAuthorizationRequest(requestId: string) {
  const { data } = await api.post<{ redirectUrl: string }>(
    `${REQUESTS}/${encodeURIComponent(requestId)}/deny`
  );
  return data.redirectUrl;
}

export async function listConnectedApps() {
  const { data } = await api.get<ConnectedApp[]>(GRANTS);
  return data;
}

export async function revokeConnectedApp(grantId: string) {
  await api.delete(`${GRANTS}/${encodeURIComponent(grantId)}`);
}
